// extracted by mini-css-extract-plugin
module.exports = {"container":"BusyIndicator_container__22bxw","fullScreen":"BusyIndicator_fullScreen__t4OHQ","text":"BusyIndicator_text__1T2DU"};